import { Component, Prop, h, Host } from '@stencil/core';
import { Logger, SectionBehavior, VerticalPositionBottom, VerticalPositionTop } from '../../global/_types';
import { getSectionBehavior, renderBlockMargin } from '../../global/_utils';

@Component({
  tag: 'cms-flexible-text',
  styleUrl: 'cms-flexible-text.scss',
  shadow: true,
})
export class CmsFlexibleText {
  @Prop() config: string | CmsFlexibleTextConfig;
  @Prop() debug: boolean;

  @Prop() behavior: string = '{}';

  private logger: Logger;

  private options: CmsFlexibleTextConfig;

  private position: string = 'center';
  private size: number = 56;

  /* SectionBehavior */
  private sectionBehavior: SectionBehavior;

  componentWillLoad() {
    this.logger = new Logger(this.debug, 'CmsFlexibleText');

    this.options = typeof(this.config) === 'string' ?
      JSON.parse(this.config) as CmsFlexibleTextConfig :
      this.config;

    this.position = this.options.position || this.position;
    this.size = this.options.size || this.size;

    this.sectionBehavior = getSectionBehavior(this.behavior);
  }

  componentDidLoad() {
    this.logger.trace('CmsFlexibleText loaded');
  }

  render() {
    // text-position
    const textClass = `text-position-${this.position} text-${this.size}`;
    const textSublineClass = this.options.subline ? `text-position-${this.position} text-${this.options.subline.size}` : '';

    // text
    const text = this.options.text.replace('\\n', '<br>');

    // attributes
    const attributes = {
      class: textClass,
      style: {
        color: this.options.color,
      },
      innerHTML: text,
    };

    // content
    const content = <this.options.tag {...attributes}/>;

    // subline
    const subline = this.options.subline ? <this.options.subline.tag class={textSublineClass} style={attributes.style} innerHTML={this.options.subline.text}/> : '';

    return (
      <Host class={this.sectionBehavior.hostClass}>
        <section class={this.sectionBehavior.sectionClass} style={this.sectionBehavior.sectionStyle}>
          { renderBlockMargin(this.sectionBehavior, VerticalPositionTop) }
          <div class={`section-inner wrapper position-${this.position}`}>
            <div class="inner">
              {content}
              {subline}
            </div>
          </div>

          { renderBlockMargin(this.sectionBehavior, VerticalPositionBottom) }
        </section>
      </Host>
    );
  }
}

export interface CmsFlexibleTextConfig {
  text: string;
  tag: string;
  color?: string;
  position?: string;
  size?: number;
  subline?: CmsFlexibleTextSublineConfig;
}

interface CmsFlexibleTextSublineConfig {
  text: string;
  tag: string;
  size: number;
}
